import httpAuth from '../../services/httpAuth'
import httpNotAuth from '../../services/httpNotAuth'
import getErrorMessage from '../../helpers/getErrorMessage.helper'
import {
  getSlotsGamesError,
  mainGames,
  allSlots,
  fishingGames,
  bingoGames,
  multiplayerGames,
  virtualGames,
  scratchGames,
  getSlotsGamesIDSuccess,
  getSlotsGamesIDError,
  getSlotsGamesButtonsSuccess,
  selectedSectionIdWiseSlotsGames,
  getSlotsGamesProviderSuccess,
  allGamesProviderWise,
} from './slotsGames.slice'
import axios from 'axios'
import { BASE_DEV_URL } from '../../config/api.config'

export const requestSlotsGames = () => async (dispatch, getState) => {
  const checkAuth = getState().auth

  try {
    const response = await httpAuth.get(`casino/v3/lobby?type=rng`)
    console.log('response', response)
    if (response.data.success) {
      dispatch(
        mainGames(response.data.result?.sort((a, b) => a?.index - b?.index))
      )
      dispatch(getSlotsGamesButtonsSuccess(response.data.result))
    }
    return response
  } catch (e) {
    dispatch(getSlotsGamesError())
    // const errorMsg = getErrorMessage(e)
    // throw errorMsg
  }
}

export const requestSlotsGamesLobby = (id) => async (dispatch, getState) => {
  try {
    const response = await httpAuth.get(`casino/v3/categories?categoryId=${id}`)
    if (response.data.success) {
      dispatch(selectedSectionIdWiseSlotsGames(response.data.result))
    }
    return response
  } catch (e) {
    dispatch(getSlotsGamesError())
    // const errorMsg = getErrorMessage(e)
    // throw errorMsg
  }
}

export const requestSlotsGamesID = (id, type) => async (dispatch) => {
  const token = localStorage.getItem('id_token')
  try {
    const response = await axios.post(
      BASE_DEV_URL + `/casino/live/session/open`,
      {
        id: id,
        type: type,
      },
      {
        headers: {
          Authorization: `${token}`,
        },
      }
    )
    if (response.data.success) {
      // window.open(response?.data?.result?.url)

      dispatch(getSlotsGamesIDSuccess(response.data.result))
    }
    return response
  } catch (e) {
    dispatch(getSlotsGamesIDError())
    const errorMsg = getErrorMessage(e)
    throw errorMsg
  }
}

export const requestJILIGamesID = (id) => async (dispatch) => {
  const token = localStorage.getItem('id_token')
  try {
    const response = await axios.get(
      BASE_DEV_URL + `/casino/live/table/${id}`,
      {
        headers: {
          Authorization: `${token}`,
        },
      }
    )
    if (response.data.success) {
      //   window.open(response?.data?.result?.url)
      dispatch(getSlotsGamesIDSuccess(response.data.result))
    }
    return response
  } catch (e) {
    dispatch(getSlotsGamesIDError())
    const errorMsg = getErrorMessage(e)
    throw errorMsg
  }
}

export const requestSlotGamesProvider = (id, name) => async (dispatch) => {
  const token = localStorage.getItem('id_token')
  try {
    const response = await axios.get(BASE_DEV_URL + `/casino/v3/providers`, {
      params: {
        developerId: id ? id : 0,
      },
      headers: {
        Authorization: `${token}`,
      },
    })

    if (response.data.success) {
      if (id == 0) {
        dispatch(
          getSlotsGamesProviderSuccess(
            response.data.result
              ?.filter((item) => item?.isB2b && item?.isRng)
              .sort((a, b) => a?.index - b?.index)
          )
        )
        // dispatch(getSlotsGamesProviderSuccess(response?.data?.result))
      } else {
        dispatch(allGamesProviderWise(
          response.data.result.sort((a, b) => a?.index - b?.index)
        ))
      }
      //   after success get all games provider wise
    }
    return response
  } catch (error) {
    console.error('error', error)
  }
}
